import { CapoPlugin } from "/tmp/my-website-master/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];